import markApplicationReducer from "./markApplicationReducer";

const markApplicationReducers = {
    markApplication: markApplicationReducer,
};

export default markApplicationReducers;